export default __webpack_public_path__ + "static/4-0570a7265b8283a02094f270c19fd5dd.png";